import { PaymentFailContainer } from "../containers/PaymentFailContainer";

export const PaymentFailPage = () => <PaymentFailContainer />;
